import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatChipsModule } from "@angular/material/chips";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { TranslocoModule } from "@jsverse/transloco";

import { LorenAssetSelectionComponent } from "./loren-asset-selection/loren-asset-selection.component";
import { LorenImageModule } from "../../pipes/loren-image/loren-image.module";

@NgModule({
  declarations: [LorenAssetSelectionComponent],
  exports: [LorenAssetSelectionComponent],
  imports: [
    CommonModule,
    MatInputModule,
    MatChipsModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    MatIconModule,
    TranslocoModule,
    LorenImageModule,
  ],
})
export class LorenAssetSelectionModule {}
